import { goodsType, goodsBelongLabels, platformType, thirdPartyType, shippingMode, cycleTypes,
  collectionsLabels, goodsState, paymentModes } from 'json/mall-options'
export let goodsTableLabels = [
//   {
//     label: '浏览量',
//     value: 'goodsOtherInfoDTO.visitorVolume'
//   },
//   {
//     label: '库存',
//     value: 'goodsOtherInfoDTO.stockQuantity'
//   },
//   {
//     label: '销量',
//     value: 'goodsOtherInfoDTO.saleVolume'
//   },
  {
    label: '事业部归属',
    minWidth: 90,
    value: 'goodsDTO.goodsData.businessDepartmentName'
  },
  {
    label: '上架时间',
    minWidth: 100,
    value: 'putOnSaleTime'
  },
  {
    label: '类型',
    value: 'goodsDTO.goodsData.typeName'
  },
  {
    label: '分组',
    value: 'goodsDTO.goodsData.groupName'
  },
  {
    label: '是否在商城展示',
    value: 'mall_visible'
  }
//   {
//     label: '推荐值',
//     value: 'goodsOtherInfoDTO.recommend'
//   },
//   {
//     label: '商品状态',
//     value: 'goods_state'
//   }
]
export let goodsStates = goodsState
export let filterFactor = [
  {
    label: '归属',
    value: 'goodsBelong',
    clearable: true,
    type: 'select',
    options: goodsBelongLabels
  },
  {
    label: '类型',
    type: 'select',
    clearable: true,
    value: 'type', // 需返回数据的字段名
    options: [],
    props: {
      label: 'name',
      value: 'value'
    }
  },
  {
    label: '分组',
    type: 'select',
    clearable: true,
    value: 'groupId', // 需返回数据的字段名
    options: [],
    props: {
      label: 'name',
      value: 'id'
    }
  },
  {
    label: '状态',
    type: 'select',
    value: 'state',
    clearable: true,
    options: goodsStates
  },
  {
    label: '价格',
    clearable: true,
    type: 'price-slot',
    minName: 'priceIntervalMin',
    maxName: 'priceIntervalMax',
    value: 'priceInterval'
  },
  {
    label: '发布时间',
    clearable: true,
    startName: 'createdDateStart',
    endName: 'createdDateEnd',
    type: 'time-slot',
    value: 'publishTime'
  },
  {
    label: '第三方供应商',
    type: 'select',
    value: 'vendorId',
    props: { label: 'name', value: 'id' },
    clearable: true,
    options: []
  }
// {
//   label: 'time',
//   type: 'time-slot',
//   startName: 'start-time', // 返回数据时，开始时间的字段名
//   endName: 'end-time', // 返回数据时，结束时间的字段名
//   value: 'createdtime',
//   options: []
// },
// {
//   label: 'time',
//   type: 'time-slot',
//   startName: 'start-time', // 返回数据时，开始时间的字段名
//   endName: 'end-time', // 返回数据时，结束时间的字段名
//   value: 'endtime', // 如果有多个时间段组件，每个时间段组件对应的字段名
//   options: []
// }
]
export let logisticsMessage = [
  {
    label: '统一邮费',
    value: 'uniform',
    is_slot: true,
    slot_type: 'input',
    input_slot_name: 'append',
    input_slot_icon: '¥'
  },
  {
    label: '邮费模板',
    value: 'mobile',
    is_slot: true,
    slot_type: 'select'

  }
]
export let platformTypes = platformType
export let thirdPartyTypes = thirdPartyType
export let goodsTypes = goodsType
export let goodsGroup = [
]
export let goodsTags = []
export let labelsListTabs = [
  {
    label: '商品标签',
    value: 'goods_label'
  },
  {
    label: '用户标签',
    value: 'user_label'
  },
  {
    label: '检测项标签',
    value: 'test_label'
  }
]
export let labelsTabelLabel = [
  {
    label: '标签名称',
    value: ''
  },
  {
    label: '相关商品',
    value: ''
  }
]
export let cycleRadios = cycleTypes
export let mealListLabels = [
  {
    label: '套餐名称',
    value: 'name'
  },
  {
    label: '实验室检测平台',
    value: 'productBean.name'
  },
  {
    label: '检测项个数',
    value: 'detectionItemCount'
  },
  {
    label: '创建时间',
    value: 'createdTime'
  }
]
// 商品归属枚举
export let BelongLabels = goodsBelongLabels
// 商品是否需发货
export let shippingModes = shippingMode
// 收款账户枚举
export let collectionsLabel = collectionsLabels
// 选择标签时，标签列表的表头
export let lablesTableLabels = [
  {
    label: '标签名称',
    value: 'name'
  },
  {
    label: '相关商品（个）',
    value: 'relatedObjectNumber'
  }
]
// 提供发票与否
export let provideInvoiceList = [
  {
    label: '是',
    value: 'true'
  },
  {
    label: '否',
    value: 'false'
  }
]
// 支付方式
export let paymentModesOptions = paymentModes
